import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_CONFIG, APP_CONFIG_LOCAL } from '../../../core/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(public httpClient: HttpClient) { }

  authenticateUser(requestBody: any): Observable<any> {
    if (window.location.hostname === 'localhost') {
      return this.httpClient.get<any>(APP_CONFIG_LOCAL.LOCAL_LOGIN);
    } else {
      return this.httpClient.post<any>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.LOGIN}`, requestBody);
    }
  }
}
